import instance from "../axiosConfig";
import { Element, ElementPage } from "./models";

export class ElementService {
    private regionCode: string;
    private languageCode: string;

    constructor(regionCode: string, languageCode: string) {
        this.regionCode = regionCode;
        this.languageCode = `${regionCode}-${languageCode}`;
    }

    get = async (version: string = ""): Promise<Element[]> => {
        const response = await instance.get<Element[]>(
            `api/regions/${this.regionCode}/languages/${this.languageCode}/elementpages?version=${version}`
        );

        const elements = response.data;
        elements.forEach((x) => (x.name ??= "-"));

        return elements;
    };

    getPage = async (slug: string, version: string = "") => {
        try {
            const response = await instance.get<ElementPage | null>(
                `api/regions/${this.regionCode}/languages/${this.languageCode}/elementpages/${slug}?version=${version}`
            );

            if (response.status === 404) return null;

            return response.data;
        } catch {
            return null;
        }
    };

    export = async (
        softwareIds: string[],
        disciplineIds: string[],
        useCaseIds: string[],
        classificationId: string | null,
        elementIds: string[],
        includeImages: boolean,
        version?: string,
        signal?: AbortSignal
    ) => {
        const response = await instance.post<string>(
            `api/regions/${this.regionCode}/languages/${this.languageCode}/elementpages/export?version=${version}`,
            {
                softwareIds,
                disciplineIds,
                useCaseIds,
                classificationIds: classificationId ? [classificationId] : [],
                elementIds,
                showImages: includeImages,
            },
            {
                responseType: "blob",
                signal,
            }
        );

        return new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    };

    exportStructured = async (
        softwareIds: string[],
        disciplineIds: string[],
        useCaseIds: string[],
        classificationId: string | null,
        elementIds: string[],
        includeImages: boolean,
        version?: string,
        signal?: AbortSignal
    ) => {
        const response = await instance.post<string>(
            `api/regions/${this.regionCode}/languages/${this.languageCode}/elementpages/export2?version=${version}`,
            {
                softwareIds,
                disciplineIds,
                useCaseIds,
                classificationIds: classificationId ? [classificationId] : [],
                elementIds,
                showImages: includeImages,
            },
            {
                responseType: "blob",
                signal,
            }
        );

        return new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    };

    unsubscribe = async (key: string) => {
        const response = await instance.get(
            `api/regions/${this.regionCode}/languages/${this.languageCode}/elementpages/unsubscribe/${key}`
        );

        return response.data;
    };
}
